import { COLORS } from '@/constants'
import { Typography } from '@mui/material'
import { Head, Wrapper } from '@/features/pages/home'
import { FC, useMemo } from 'react'
import { Container } from '../../styles'
import { useGetHousingList } from '@/queris'
import { SearchListFilters } from '@/types'
import { getExpandedFilters } from '@/common'
import { useTranslations } from 'next-intl'
import { Carousel } from '@/features/pages/home/components/Featured/Carousel'


type FeaturedBlockProps = {
  filters: SearchListFilters | undefined;
  excludedIds?: (string | number)[];
};

export const FeaturedCards: FC<FeaturedBlockProps> = ({ filters, excludedIds = [] }) => {
  const t = useTranslations();

  const shiftedFilters = useMemo(
    () => getExpandedFilters(filters),
    [filters]
  );
  const { data } = useGetHousingList(shiftedFilters, {
    enabled: !!shiftedFilters,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  const featuredObjects = useMemo(() => data?.objects.filter(o => !excludedIds.includes(o.id)),
    [data, excludedIds]);

  if (!featuredObjects?.length) return null;

  return (
    <Wrapper $bgColor="blue">
      <Container>
        <Head>
          <Typography fontSize={34} lineHeight={1} fontWeight={700} color={COLORS["white"]}>
            {t("featuredObjects.title")}
          </Typography>
          <Typography fontSize={18} lineHeight={1.26} fontWeight={600} color={COLORS["primary/300"]}>
            {t("featuredObjects.desc")}
          </Typography>
        </Head>
        <Carousel data={featuredObjects} />
      </Container>
    </Wrapper>
  );
};